<template>
  <div class="cfs-field d-flex flex-column">
    <p class="input-title px-1 pb-1" :class="{ disabled }">
      {{ sharp ? `${label} #` : label }}
    </p>
    <slot />
  </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'CfsFormGroup',
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    sharp: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
  },
});
</script>
